import React from "react";
import { ArrowLeft } from "lucide-react";

export function VolverButton({ onClick, testid = "panel-volver", className = "" }) {
  return (
    <button type="button" onClick={onClick} title="Volver a la página anterior" data-testid={testid}
            className={`shrink-0 inline-flex items-center gap-2 rounded-full bg-slate-900 text-white pl-3 pr-4 py-2 text-sm font-semibold shadow hover:bg-slate-700 transition-colors ${className}`}>
      <ArrowLeft size={18} /> Volver
    </button>
  );
}
